// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-strip {
    border-bottom: 0.35px solid #FFFFFF;
    min-height: 42px;
    color: #FFFFFF;
    text-align: right;
    display: flex;
    align-items: center;
    transition: 0.3s all ease-in-out;
    z-index: 99;
    background: #FAFAFA;
}

.header-strip .wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-strip .wrap .dropdown .dropdown-menu {
    background: #F3F0EB;
    border-radius: 0px 0px 8px 8px;
    min-width: auto;
}

.header-strip .wrap .dropdown .dropdown-toggle {
    font-size: 14px;
    line-height: 24px;
    font-weight: 600;
    color: #F9FAFB;
    margin-right: 85px;
}

.header-strip .wrap .dropdown a:hover {
    color: #549CAC;
}

.header-strip .dropdown .dropdown-menu.show {
    opacity: 1;
}

.header-strip .dropdown-menu .dropdown-item:hover {
    color: #549CAC;
    background: none;
}

.header-strip .wrap .media {
    padding-left: 7.64px;
}

.header-strip .wrap .nav-link a {
    color: #808282;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.header-strip .wrap .nav-link:not(:last-child) {
    padding-left: 5px;
    padding-right: 10px;
}

.header-strip .wrap .search {
    padding-left: 2px;
}

.header-strip .wrap svg {
    fill: #808282;
}

.header-strip .wrap svg:hover {
    fill: #549CAC;
}

/* Header*/
#header.fixed-top {
    height: 82px;
    margin-top: 41px;
    z-index: 9;
    transition: 0.3s all ease-in-out;
    background: #FFFFFF;
}

header .navbar-brand .logo {
    width: 100%;
}

header .navbar .navbar-nav .nav-item:not(:last-child) {
    padding-left: 41.33px;
}

header .navbar .navbar-nav .nav-item .nav-link {
    color: #000;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    transition: 0.6s all ease-in-out;
}

header .navbar-nav .nav-item .nav-link.active,
header .navbar-nav .nav-item .nav-link:hover {
    color: #549CAC;
}

header .navbar-nav .btn {
    width: 156px;
    margin-left: 12.35px;
}

/* Dropdown Menu*/
header .navbar .dropdown .dropdown-menu {
    min-width: 277px;
    margin-top: 0;
    top: 36px;
    left: unset;
    background: #F3F0EB;
    border-radius: 0px 0px 8px 8px;
    padding: 34px 25px 34px 45px;
    overflow: hidden;
    transform-origin: top center;
    transform: scale(1, 0);
    display: block;
    opacity: 0;
    transition: 0.6s all ease-in-out;
}

header .navbar .dropdown:hover .dropdown-menu {
    transform: scale(1, 1);
    opacity: 1;
}


.navbar .navbar-nav .dropdown-menu li:not(:last-child) {
    margin-bottom: 19px;
}

.navbar .navbar-nav .dropdown-menu .dropdown-item:hover {
    color: #549CAC;
    background: none;
}

header .navbar-nav .sub-nav {
    padding: 25px 0 0 19px;
}

header .navbar-nav .dropdown-menu .sub-nav .dropdown-item {
    font-weight: 500;
}

/* Header Active*/
#header-strip.active {
    background-color: #fff;
}

#header.fixed-top.active {
    border-top: 0.35px solid #FFFFFF;
    background: #fff;
}

#header .nav-item {
    position: relative;
}

#header a.nav-text.active {
    color: #163873 !important;
    font-weight: 700 !important;
}

#header a.nav-text:hover {
    color: #163873 !important;
    font-weight: 700 !important;
}

#header a:hover:after {
    content: "";
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, 100%);
    width: 10px;
    height: 10px;
    background: #163873;
    border-radius: 50%;
}

#header a.active:after {
    content: "";
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, 100%);
    width: 10px;
    height: 10px;
    background: #163873;
    border-radius: 50%;
}
.header-logo {
    cursor: pointer;
}
.nav-text {
    color: #000000;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
}

.inner-header #header-strip,
.inner-header #header.fixed-top {
    background: #221C1D;
}

/* New css added header part */
.svgStyle {
    font-size: 20px !important;
    font-weight: 500 !important;
}

.line-header {
    width: 1px;
    height: 24px;
}

/* Desktop Search bar*/
@media (min-width: 576px) {
    .search-modal.modal {
        background-color: rgba(243, 111, 33, 0.78);
    }

    .search-modal .modal-dialog {
        max-width: 784.74px;
    }
}

.search-modal .modal-content {
    border-radius: 8px;
}

.search-modal .input-group {
    height: 63px;
}

.search-modal .input-group-text:first-child {
    background-color: transparent;
    border: 0;
}

.search-modal .form-control {
    border: 0;
    font-size: 22.1053px;
    line-height: 30px;
    color: #C4C4C4;
}

.search-modal .form-control::placeholder {
    color: #C4C4C4;
}

.search-modal .btn.btn-search {
    width: 154px;
    margin: 7.5px;
}

.input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
    border-radius: 3px;
}

/* Mobile Search bar*/
.search-mb {
    z-index: 9999;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    background: rgba(26, 25, 25, 0.8);
    height: 100vh;
    transition: 0.0s all ease-in-out;
}

.search-mb .wrap {
    padding: 21px 15px;
    background-color: #549CAC;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
}

.search-mb .form-control {
    font-size: 16px;
    line-height: 24px;
    color: #6B7280;
    height: 42px;
    border: 0;
}

.search-mb .form-control::placeholder {
    color: #6B7280;
}

.search-mb .input-group {
    background-color: #FFFFFF;
    border: 1px solid #CA424C;
    border-radius: 6px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px #6366F1;
}

.search-mb .input-group-text {
    background-color: #FFFFFF;
    border: 0;
}

header .navbar-toggler:focus {
    box-shadow: none;
}
.toggle-class {
    position: absolute;
    right: 0px;
    margin-right: 15px;
  }
@media (max-width: 1399.98px) {
    header .navbar-brand .logo {
        width: 280px;
    }

    header .navbar .navbar-nav .nav-item:not(:last-child) {
        padding-left: 10px;
    }

    header .navbar .navbar-nav .nav-item .nav-link,
    .navbar .navbar-nav .dropdown-menu .dropdown-item {
        font-size: 16px;
    }

    header .navbar .dropdown .dropdown-menu {
        min-width: auto;
        padding: 20px;
    }

    header .navbar-nav .btn {
        font-size: 16px;
        width: 120px;
        margin-left: 10px;
        padding: 13px 10px 12px;
    }
}

@media (max-width: 1199.98px) {
    header .navbar-brand .logo {
        width: 229px;
    }

    header .navbar .navbar-nav .nav-item .nav-link {
        font-size: 14px;
    }

    header .navbar-nav .btn {
        font-size: 14px;
        width: 90px;
        margin-left: 10px;
        padding: 13px 10px 12px;
    }
}

@media (max-width: 991.98px) {
    header .header-strip {
        background-color: #FAFAFA;
        border-bottom: 0;
       
    }
    #header a:hover:after {
        display: none !important;
    }

    #header a.active:after {
        display: none;
    }

    #header .small-screen-css {
        background-color: rgb(255, 255, 255);
        position: absolute !important;
        top: 0px !important;
        left: 0 !important;
        width: 87% !important;
        padding-top: 40px !important;
        height: 100vh !important;
        z-index: 999 !important;
        box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px rgba(0, 0, 0, 0.05)
    }

    #header.fixed-top {
        background-color: #ffffff;
        margin-top: 0;
    }

    #header.fixed-top.active {
        border-top: 0;
    }

    .header-strip .wrap {
        display: none;
    }

    header .navbar-brand .logo {
        width: 100%;
        margin-left: 0;
    }

    header .navbar .navbar-nav .nav-item .nav-link {
        font-size: 18.5985px;
    }

    header .navbar .navbar-toggler {
        background-color: #E7E1D8;
        border-radius: 8.53125px;
        border: 0;
        width: 56.88px;
        height: 56.88px;
    }

    header .navbar .dropdown .dropdown-menu {
        transform: unset;
        display: none;
        background: transparent;
        transition: 0.6s all ease-in-out;
    }

    header .navbar .dropdown .dropdown-menu.show {
        display: block;
        border: 0;
        box-shadow: unset;
        border-radius: 0;
        padding: 0 0 0 20px;
        opacity: 1;
        transition: 0.6s all ease-in-out;
    }
 
    .header-strip {
        background: none !important;
        border: none !important;
        z-index: 1;
        display: none !important;
    }

    .navbar-collapse {
        position: absolute !important;
        top: 0px !important;
        left: 0 !important;
        width: 87% !important;
        padding-top: 40px !important;
        height: 100vh !important;
        z-index: 999 !important;
    }

    header .navbar .navbar-collapse.collapsing {
        left: -100% !important;
        transition: height 0s ease !important;
        background: #F3F0EB !important;
        box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px rgba(0, 0, 0, 0.05) !important;
    }

    header .navbar .navbar-collapse.show {
        transition: left 500ms ease-in-out;
        background: #F3F0EB;
        box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px rgba(0, 0, 0, 0.05);
    }

    header .navbar .navbar-toggler.collapsed~.navbar-collapse {
        transition: left 500ms ease-in-out;
    }

    header .navbar .navbar-collapse.show .navbar-toggler {
        background: rgba(35, 31, 32, 0.2);
    }

    header .navbar .navbar-nav .nav-item:not(:last-child) {
        padding-left: 0;
    }

    header .navbar .dropdown a[aria-expanded="false"] span {
        font-size: 20px;
        line-height: 24px;
        color: #111827;
    }

    header .navbar .dropdown .dropdown-toggle::after {
        /* content: url('../images/icons/dropdown-toggle-mb.png'); */
        display: none;
    }

    header .navbar .dropdown a[aria-expanded="false"]:hover::after,
    header .navbar .dropdown a[aria-expanded="false"]:focus::after {
        transform: rotate(-90deg);
    }

    header .navbar .navbar-nav .nav-item {
        margin-bottom: 29px;
    }

    .navbar .navbar-nav .dropdown-menu li {
        margin-top: 29px;
    }

    header .navbar-nav .sub-nav {
        padding: 0px 0 0 19px;
    }

    header .navbar .navbar-nav .btn {
        margin-left: 0;
    }

    header .navbar .nav-2 {
        border-top: 1px solid rgba(0, 0, 0, .1);
    }

    header .navbar .nav-2 li:not(:last-child) {
        margin: 16px 0;
    }

    header .nav-2 a {
        font-size: 16px;
        line-height: 24px;
        color: #231F20;
    }

    header .navbar .nav-2 a:hover {
        color: #5F281E;
    }

    header .navbar .nav-2 .media {
        display: flex;
        align-items: center;
        margin-top: 40px;
    }

    header .navbar .nav-2 .media li:not(:last-child) {
        padding-right: 14.22px;
    }

    header .nav-2 .media li svg {
        fill: #5F281E;
    }

    header .navbar .nav-2 .media li:hover svg {
        fill: #111827;
    }

}

@media (max-width: 374px) {
    header .navbar-brand .logo {
        width: 100%;
        margin-left: 0px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/userpenal/styles/style-header.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA,UAAU;AACV;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;IAC5B,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;IACtB,cAAc;IACd,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,UAAU;AACd;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA,sBAAsB;AACtB;IACI;QACI,0CAA0C;IAC9C;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,MAAM;IACN,OAAO;IACP,iCAAiC;IACjC,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,2EAA2E;AAC/E;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,oEAAoE;AACxE;;AAEA;IACI,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;EACpB;AACF;IACI;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,iBAAiB;QACjB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,gBAAgB;;IAEpB;IACA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oCAAoC;QACpC,6BAA6B;QAC7B,mBAAmB;QACnB,kBAAkB;QAClB,qBAAqB;QACrB,4BAA4B;QAC5B,wBAAwB;QACxB,uBAAuB;QACvB;IACJ;;IAEA;QACI,yBAAyB;QACzB,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,yBAAyB;QACzB,wBAAwB;QACxB,SAAS;QACT,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,uBAAuB;QACvB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,SAAS;QACT,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,UAAU;QACV,gCAAgC;IACpC;;IAEA;QACI,2BAA2B;QAC3B,uBAAuB;QACvB,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,6BAA6B;QAC7B,mBAAmB;QACnB,kBAAkB;QAClB,qBAAqB;QACrB,4BAA4B;QAC5B,wBAAwB;QACxB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,qCAAqC;QACrC,8BAA8B;QAC9B,uIAAuI;IAC3I;;IAEA;QACI,kCAAkC;QAClC,mBAAmB;QACnB,4HAA4H;IAChI;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,4DAA4D;QAC5D,aAAa;IACjB;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ","sourcesContent":[".header-strip {\n    border-bottom: 0.35px solid #FFFFFF;\n    min-height: 42px;\n    color: #FFFFFF;\n    text-align: right;\n    display: flex;\n    align-items: center;\n    transition: 0.3s all ease-in-out;\n    z-index: 99;\n    background: #FAFAFA;\n}\n\n.header-strip .wrap {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.header-strip .wrap .dropdown .dropdown-menu {\n    background: #F3F0EB;\n    border-radius: 0px 0px 8px 8px;\n    min-width: auto;\n}\n\n.header-strip .wrap .dropdown .dropdown-toggle {\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 600;\n    color: #F9FAFB;\n    margin-right: 85px;\n}\n\n.header-strip .wrap .dropdown a:hover {\n    color: #549CAC;\n}\n\n.header-strip .dropdown .dropdown-menu.show {\n    opacity: 1;\n}\n\n.header-strip .dropdown-menu .dropdown-item:hover {\n    color: #549CAC;\n    background: none;\n}\n\n.header-strip .wrap .media {\n    padding-left: 7.64px;\n}\n\n.header-strip .wrap .nav-link a {\n    color: #808282;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.header-strip .wrap .nav-link:not(:last-child) {\n    padding-left: 5px;\n    padding-right: 10px;\n}\n\n.header-strip .wrap .search {\n    padding-left: 2px;\n}\n\n.header-strip .wrap svg {\n    fill: #808282;\n}\n\n.header-strip .wrap svg:hover {\n    fill: #549CAC;\n}\n\n/* Header*/\n#header.fixed-top {\n    height: 82px;\n    margin-top: 41px;\n    z-index: 9;\n    transition: 0.3s all ease-in-out;\n    background: #FFFFFF;\n}\n\nheader .navbar-brand .logo {\n    width: 100%;\n}\n\nheader .navbar .navbar-nav .nav-item:not(:last-child) {\n    padding-left: 41.33px;\n}\n\nheader .navbar .navbar-nav .nav-item .nav-link {\n    color: #000;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    transition: 0.6s all ease-in-out;\n}\n\nheader .navbar-nav .nav-item .nav-link.active,\nheader .navbar-nav .nav-item .nav-link:hover {\n    color: #549CAC;\n}\n\nheader .navbar-nav .btn {\n    width: 156px;\n    margin-left: 12.35px;\n}\n\n/* Dropdown Menu*/\nheader .navbar .dropdown .dropdown-menu {\n    min-width: 277px;\n    margin-top: 0;\n    top: 36px;\n    left: unset;\n    background: #F3F0EB;\n    border-radius: 0px 0px 8px 8px;\n    padding: 34px 25px 34px 45px;\n    overflow: hidden;\n    transform-origin: top center;\n    transform: scale(1, 0);\n    display: block;\n    opacity: 0;\n    transition: 0.6s all ease-in-out;\n}\n\nheader .navbar .dropdown:hover .dropdown-menu {\n    transform: scale(1, 1);\n    opacity: 1;\n}\n\n\n.navbar .navbar-nav .dropdown-menu li:not(:last-child) {\n    margin-bottom: 19px;\n}\n\n.navbar .navbar-nav .dropdown-menu .dropdown-item:hover {\n    color: #549CAC;\n    background: none;\n}\n\nheader .navbar-nav .sub-nav {\n    padding: 25px 0 0 19px;\n}\n\nheader .navbar-nav .dropdown-menu .sub-nav .dropdown-item {\n    font-weight: 500;\n}\n\n/* Header Active*/\n#header-strip.active {\n    background-color: #fff;\n}\n\n#header.fixed-top.active {\n    border-top: 0.35px solid #FFFFFF;\n    background: #fff;\n}\n\n#header .nav-item {\n    position: relative;\n}\n\n#header a.nav-text.active {\n    color: #163873 !important;\n    font-weight: 700 !important;\n}\n\n#header a.nav-text:hover {\n    color: #163873 !important;\n    font-weight: 700 !important;\n}\n\n#header a:hover:after {\n    content: \"\";\n    position: absolute;\n    top: 70%;\n    left: 50%;\n    transform: translate(-50%, 100%);\n    width: 10px;\n    height: 10px;\n    background: #163873;\n    border-radius: 50%;\n}\n\n#header a.active:after {\n    content: \"\";\n    position: absolute;\n    top: 70%;\n    left: 50%;\n    transform: translate(-50%, 100%);\n    width: 10px;\n    height: 10px;\n    background: #163873;\n    border-radius: 50%;\n}\n.header-logo {\n    cursor: pointer;\n}\n.nav-text {\n    color: #000000;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 0em;\n}\n\n.inner-header #header-strip,\n.inner-header #header.fixed-top {\n    background: #221C1D;\n}\n\n/* New css added header part */\n.svgStyle {\n    font-size: 20px !important;\n    font-weight: 500 !important;\n}\n\n.line-header {\n    width: 1px;\n    height: 24px;\n}\n\n/* Desktop Search bar*/\n@media (min-width: 576px) {\n    .search-modal.modal {\n        background-color: rgba(243, 111, 33, 0.78);\n    }\n\n    .search-modal .modal-dialog {\n        max-width: 784.74px;\n    }\n}\n\n.search-modal .modal-content {\n    border-radius: 8px;\n}\n\n.search-modal .input-group {\n    height: 63px;\n}\n\n.search-modal .input-group-text:first-child {\n    background-color: transparent;\n    border: 0;\n}\n\n.search-modal .form-control {\n    border: 0;\n    font-size: 22.1053px;\n    line-height: 30px;\n    color: #C4C4C4;\n}\n\n.search-modal .form-control::placeholder {\n    color: #C4C4C4;\n}\n\n.search-modal .btn.btn-search {\n    width: 154px;\n    margin: 7.5px;\n}\n\n.input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n    border-radius: 3px;\n}\n\n/* Mobile Search bar*/\n.search-mb {\n    z-index: 9999;\n    position: fixed;\n    width: 100%;\n    top: 0;\n    left: 0;\n    background: rgba(26, 25, 25, 0.8);\n    height: 100vh;\n    transition: 0.0s all ease-in-out;\n}\n\n.search-mb .wrap {\n    padding: 21px 15px;\n    background-color: #549CAC;\n    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.search-mb .form-control {\n    font-size: 16px;\n    line-height: 24px;\n    color: #6B7280;\n    height: 42px;\n    border: 0;\n}\n\n.search-mb .form-control::placeholder {\n    color: #6B7280;\n}\n\n.search-mb .input-group {\n    background-color: #FFFFFF;\n    border: 1px solid #CA424C;\n    border-radius: 6px;\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px #6366F1;\n}\n\n.search-mb .input-group-text {\n    background-color: #FFFFFF;\n    border: 0;\n}\n\nheader .navbar-toggler:focus {\n    box-shadow: none;\n}\n.toggle-class {\n    position: absolute;\n    right: 0px;\n    margin-right: 15px;\n  }\n@media (max-width: 1399.98px) {\n    header .navbar-brand .logo {\n        width: 280px;\n    }\n\n    header .navbar .navbar-nav .nav-item:not(:last-child) {\n        padding-left: 10px;\n    }\n\n    header .navbar .navbar-nav .nav-item .nav-link,\n    .navbar .navbar-nav .dropdown-menu .dropdown-item {\n        font-size: 16px;\n    }\n\n    header .navbar .dropdown .dropdown-menu {\n        min-width: auto;\n        padding: 20px;\n    }\n\n    header .navbar-nav .btn {\n        font-size: 16px;\n        width: 120px;\n        margin-left: 10px;\n        padding: 13px 10px 12px;\n    }\n}\n\n@media (max-width: 1199.98px) {\n    header .navbar-brand .logo {\n        width: 229px;\n    }\n\n    header .navbar .navbar-nav .nav-item .nav-link {\n        font-size: 14px;\n    }\n\n    header .navbar-nav .btn {\n        font-size: 14px;\n        width: 90px;\n        margin-left: 10px;\n        padding: 13px 10px 12px;\n    }\n}\n\n@media (max-width: 991.98px) {\n    header .header-strip {\n        background-color: #FAFAFA;\n        border-bottom: 0;\n       \n    }\n    #header a:hover:after {\n        display: none !important;\n    }\n\n    #header a.active:after {\n        display: none;\n    }\n\n    #header .small-screen-css {\n        background-color: rgb(255, 255, 255);\n        position: absolute !important;\n        top: 0px !important;\n        left: 0 !important;\n        width: 87% !important;\n        padding-top: 40px !important;\n        height: 100vh !important;\n        z-index: 999 !important;\n        box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px rgba(0, 0, 0, 0.05)\n    }\n\n    #header.fixed-top {\n        background-color: #ffffff;\n        margin-top: 0;\n    }\n\n    #header.fixed-top.active {\n        border-top: 0;\n    }\n\n    .header-strip .wrap {\n        display: none;\n    }\n\n    header .navbar-brand .logo {\n        width: 100%;\n        margin-left: 0;\n    }\n\n    header .navbar .navbar-nav .nav-item .nav-link {\n        font-size: 18.5985px;\n    }\n\n    header .navbar .navbar-toggler {\n        background-color: #E7E1D8;\n        border-radius: 8.53125px;\n        border: 0;\n        width: 56.88px;\n        height: 56.88px;\n    }\n\n    header .navbar .dropdown .dropdown-menu {\n        transform: unset;\n        display: none;\n        background: transparent;\n        transition: 0.6s all ease-in-out;\n    }\n\n    header .navbar .dropdown .dropdown-menu.show {\n        display: block;\n        border: 0;\n        box-shadow: unset;\n        border-radius: 0;\n        padding: 0 0 0 20px;\n        opacity: 1;\n        transition: 0.6s all ease-in-out;\n    }\n \n    .header-strip {\n        background: none !important;\n        border: none !important;\n        z-index: 1;\n        display: none !important;\n    }\n\n    .navbar-collapse {\n        position: absolute !important;\n        top: 0px !important;\n        left: 0 !important;\n        width: 87% !important;\n        padding-top: 40px !important;\n        height: 100vh !important;\n        z-index: 999 !important;\n    }\n\n    header .navbar .navbar-collapse.collapsing {\n        left: -100% !important;\n        transition: height 0s ease !important;\n        background: #F3F0EB !important;\n        box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px rgba(0, 0, 0, 0.05) !important;\n    }\n\n    header .navbar .navbar-collapse.show {\n        transition: left 500ms ease-in-out;\n        background: #F3F0EB;\n        box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px rgba(0, 0, 0, 0.05);\n    }\n\n    header .navbar .navbar-toggler.collapsed~.navbar-collapse {\n        transition: left 500ms ease-in-out;\n    }\n\n    header .navbar .navbar-collapse.show .navbar-toggler {\n        background: rgba(35, 31, 32, 0.2);\n    }\n\n    header .navbar .navbar-nav .nav-item:not(:last-child) {\n        padding-left: 0;\n    }\n\n    header .navbar .dropdown a[aria-expanded=\"false\"] span {\n        font-size: 20px;\n        line-height: 24px;\n        color: #111827;\n    }\n\n    header .navbar .dropdown .dropdown-toggle::after {\n        /* content: url('../images/icons/dropdown-toggle-mb.png'); */\n        display: none;\n    }\n\n    header .navbar .dropdown a[aria-expanded=\"false\"]:hover::after,\n    header .navbar .dropdown a[aria-expanded=\"false\"]:focus::after {\n        transform: rotate(-90deg);\n    }\n\n    header .navbar .navbar-nav .nav-item {\n        margin-bottom: 29px;\n    }\n\n    .navbar .navbar-nav .dropdown-menu li {\n        margin-top: 29px;\n    }\n\n    header .navbar-nav .sub-nav {\n        padding: 0px 0 0 19px;\n    }\n\n    header .navbar .navbar-nav .btn {\n        margin-left: 0;\n    }\n\n    header .navbar .nav-2 {\n        border-top: 1px solid rgba(0, 0, 0, .1);\n    }\n\n    header .navbar .nav-2 li:not(:last-child) {\n        margin: 16px 0;\n    }\n\n    header .nav-2 a {\n        font-size: 16px;\n        line-height: 24px;\n        color: #231F20;\n    }\n\n    header .navbar .nav-2 a:hover {\n        color: #5F281E;\n    }\n\n    header .navbar .nav-2 .media {\n        display: flex;\n        align-items: center;\n        margin-top: 40px;\n    }\n\n    header .navbar .nav-2 .media li:not(:last-child) {\n        padding-right: 14.22px;\n    }\n\n    header .nav-2 .media li svg {\n        fill: #5F281E;\n    }\n\n    header .navbar .nav-2 .media li:hover svg {\n        fill: #111827;\n    }\n\n}\n\n@media (max-width: 374px) {\n    header .navbar-brand .logo {\n        width: 100%;\n        margin-left: 0px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
